import React, { useEffect, useRef, useState } from "react"
import { Link, graphql } from "gatsby"
import { DrSubTitle } from "../libs/helpers"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { BlocksRenderer } from "@strapi/blocks-react-renderer"
import { HtmlTag, Cta, DOCTOR_BASE_SLUG } from "../libs/helpers"
import Slider from "react-slick"

import * as styles from "./homedoctor.module.scss"

const HomeDoctorItem = ({ branch, image, job, name, slug }) => {
  const img = image ? getImage(image.localFile) : undefined

  return (
    <div className={styles['doctorItem']}>
      <div>
        { img &&
          <GatsbyImage image={img} alt={image.alternativeText || 'alt'} className={styles['image']} />
        }
        { name &&
        <h4 className={styles['name']}>{name}</h4>
        }
        { branch && job &&
        <p className={styles['job']}>{job}, {branch}</p>
        }
        { slug &&
        <Link to={`${DOCTOR_BASE_SLUG}/${slug}`} className={styles['link'] + " view--btn"}>View Day</Link>
        }
      </div>
    </div>
  )
}

const HomeDoctor = ({ cta, description, eyebrow, title, doctors }) => {
  const [activeSlide, setActiveSlide] = useState(0)
  const settings = {
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    slidesToScroll: 1,
    slidesToShow: 3,
    afterChange: current => setActiveSlide(current),
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 1,
          centerPadding: '180px',
          afterChange: current => setActiveSlide(current),
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
          centerPadding: '150px',
          afterChange: current => setActiveSlide(current),
        }
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 1,
          centerPadding: '120px',
          afterChange: current => setActiveSlide(current),
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 1,
          centerPadding: '100px',
          afterChange: current => setActiveSlide(current),
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          centerPadding: '50px',
          afterChange: current => setActiveSlide(current),
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: '160px',
          afterChange: current => setActiveSlide(current),
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerPadding: '120px',
          afterChange: current => setActiveSlide(current),
        }
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
          centerPadding: '50px',
          afterChange: current => setActiveSlide(current),
        }
      }

    ]
  }
  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.slickNext()
  }
  const previous = () => {
    sliderRef.slickPrev()
  }

  useEffect(() => {
    document.querySelectorAll('.slick-slide').forEach(slide => {
      const cta = slide.querySelector('a')
      slide.getAttribute('aria-hidden') === 'true' ?
        cta.setAttribute('tabindex', '-1') :
        cta.removeAttribute('tabindex')
      // console.log(slide.getAttribute('aria-hidden'), cta)
    })
  }, [activeSlide])

  return (
    <section className={styles['wrap']}>
      <div className={styles['inner']}>
        <div className={styles['content']}>
          { eyebrow &&
          <div className={styles['eyebrow']}>
            {eyebrow}
          </div>
          }
          { title &&
          <div className={styles['title']}>
            <HtmlTag tagName={title.header}>
              {title.copy}
            </HtmlTag>
          </div>
          }
          { description &&
          <div>
            <BlocksRenderer content={description} />
          </div>
          }
          { cta &&
          <div className={styles['ctas']}>
            <Cta cta={cta} />
          </div>
          }
        </div>
        <div className={styles['carousel']}>
          <DrSubTitle />
          <Slider {...settings} ref={slider => {sliderRef = slider}}>
            {doctors.map(doctor => <HomeDoctorItem {...doctor} key={doctor.id} />)}
          </Slider>
          <div className={styles['carouselNav']}>
            <button className="button slick-prev slick-arrow" onClick={previous}>
              &lsaquo;
            </button>
            <span>
              {activeSlide + 1}/{doctors.length}
            </span>
            <button className="button slick-next slick-arrow" onClick={next}>
              &rsaquo;
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeDoctor

export const query = graphql`
  fragment HomeDoctorData on STRAPI__COMPONENT_SUPERCUSTOM_HOME_DOCTOR {
    cta {
      href
      label
    }
    description {
      children {
        text
        type
      }
      type
    }
    eyebrow
    title {
      copy
      header
    }
  }
`
